/**
 * 
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import axios from 'axios';
import ServicePath from "@/core/ServicePath"
import {
    MainRequest
} from "@/core/request";

export default class EnumRequest extends MainRequest{
    
    static listAllPersonStatus(token) {
        return this.getSEC(ServicePath.PERSON_LIST_STATUS)
    }

    static listAllMaritalStatus() {
        return this.getSEC(ServicePath.MARITAL_LIST_STATUS)
    }

    static listAllFamiliarType(token){
        return this.getSEC(ServicePath.FAMILIAR_LIST_TYPE)
    }

    static listAllPersonAntecedent(token) {
        return this.getSEC(ServicePath.ANTECEDENT_LIST_PERSON)
    }

    static listAllClinicalEventStatus(token) {
        return this.getSEC(ServicePath.CLINICAL_LIST_EVENT_STATUS)
    }

    static listAllClinicalEventType(token) {
        return this.getSEC(ServicePath.CLINICAL_LIST_EVENT_TYPE)
    }

    static listAllAppointmentStatus(token) {
        return this.getSEC(ServicePath.APPOINTMENT_LIST_STATUS)
    }

    static listAllAppointmentType(token) {
        return this.getSEC(ServicePath.APPOINTMENT_LIST_TYPE)
    }

    static listAllMedicalPracticeStatus(token) {
        return this.getSEC(ServicePath.MEDICAL_PRACTICE_LIST_STATUS)
    }

    static listAllStudyStatus(token) {
        return this.getSEC(ServicePath.STUDY_LIST_STATUS)
    }

    static listAllFinishedStudyStatus(token) {
        return this.getSEC(ServicePath.STUDY_FINISHED_LIST_TYPE)
    }

    static listAllInterpretationType(token) {
        return this.getSEC(ServicePath.INTERPRETATION_LIST_TYPE)
    }

    static listAllInterpretationStatus(token) {
        return this.getSEC(ServicePath.INTERPRETATION_LIST_STATUS)
    }

    static listAllTemplateInterpretationType(token) {
        return this.getSEC(ServicePath.INTERPRETATION_LIST_STATUS)
    }

    static listAllTemplateInterpretationStatus(token) {
        return this.getSEC(ServicePath.TEMPLATE_INTERPRETATION_LIST_STATUS)
    }

    static listAllSignStatus(token) {
        return this.getSEC(ServicePath.SIGN_LIST_STATUS)
    }

    static listAllAddendumStatus(token) {
        return this.getSEC(ServicePath.ADDENDUM_LIST_STATUS)
    }

    static listAllModalty(token) {
        return this.getSEC(ServicePath.MODALTY_LIST_SPECIALITY)
    }

    static listAllStudyPriority(token) {
        return this.getSEC(ServicePath.STUDY_LIST_PRIORITY)
    }

    static listAllDays() {
        return this.getSEC(ServicePath.BRANCH_OFFICE_DAY)
    }

    static listAllBranchOfficeTurn() {
        return this.getSEC(ServicePath.BRANCH_OFFICE_TURN)
    }

    static listAllOrderLogos() {
        return this.getSEC(ServicePath.ORDER_LOGOS)
    }

    static listAllContainerType() {
        return this.getSEC(ServicePath.CONTAINER_TYPE)
    }

    static listAllDisability() {
        return this.getSEC(ServicePath.DISABILITY_GET)
    }

}